export const providerBuilder = (userType) => (provider) => {
    // Check if the provider has user_types and then filter based on the userType ids
    const userTypeMatchesProvider = () => {
        if (!provider.attributes.user_types) return false; 
        return provider.attributes.user_types.some((item) => {
            return userType.includes(item.id);
        });
    };

    const userTypeFilter = userTypeMatchesProvider();

    return userTypeFilter;
};

export const tableDataBuilder = (data) => {
    const filterData = data.reduce((filtered, item) => {
        if (item.attributes.GameProviderDropboxUrl) {
            const row = {
                name: item.attributes.ProviderName,
                link: item.attributes.GameProviderDropboxUrl,
            };
            filtered.push(row);
        }

        return filtered;
    }, []);
    return filterData;
};